/**
 * @description configuration for pagination for the whole application
 * @author Omar Sánchez Martínez
 * @since 2025-06-26
 */

export interface PaginationSizeOption {
  value: number;
  text: string;
}

export interface PaginationConfig {
  itemsPerPage: number;
  pagesNavigationBarQuantity: number;
  paginationSizeOptions: PaginationSizeOption[];
}

/**
 * default pagination configuration
 */
export const PAGINATION_CONFIG: PaginationConfig = {
  itemsPerPage: 30,
  pagesNavigationBarQuantity: 4,
  paginationSizeOptions: [
    {
      value: 30,
      text: '30',
    },
    {
      value: 50,
      text: '50',
    },
    {
      value: 100,
      text: '100',
    },
  ],
};

/**
 * Valores por defecto para queries con paginación
 */
export const DEFAULT_PAGE = 1;
export const DEFAULT_ITEMS_PER_PAGE = PAGINATION_CONFIG.itemsPerPage;
